<template>
  <div>
    <div class="page-header d-flex w-100">
      <div class="title-col d-flex w-50">
        <span class="title-icon">
          <span class="nt-grid"></span>
        </span>
        <span class="title-text">Dashboard </span>
      </div>
      <div class="text-right ml-auto d-flex">
        <!-- <kendo-button @click="addTenant">Add New Tenant</kendo-button> -->
        <kendo-dropdownlist
          v-if="loadedPage"
          :data-source="getProducts"
          v-model="selectedProd"
          :data-text-field="'code'"
          :data-item-key="'id'"
          :data-value-field="'id'"
          @change="selectedProduct"
          :filter="'contains'"
        >
        </kendo-dropdownlist>
        <kendo-dropdownlist
          :data-source="getYears"
          :value="currentYear"
          @change="selectedYear"
          v-if="loadedPage"
          :filter="'contains'"
        >
        </kendo-dropdownlist>
        <!-- <product-select></product-select> -->
      </div>
    </div>
    <div class="page-body">
      <div class="d-flex w-100">
        <div class="w-50">
          <span class="title-text">Tenant Status Overview</span>
        </div>
      </div>
      <bar-chart
        v-if="loaded"
        :dashboardData="passingDataToBarChart"
      ></bar-chart>
    </div>
    <div class="d-flex w-100">
      <div class="text-right ml-auto">
        <kendo-dropdownlist
          v-if="loadedPage"
          :data-source="getTenantData"
          @change="selectedTenant"
          :value="tenantId"
          :data-text-field="'tenantName'"
          :data-item-key="'tenantId'"
          :data-value-field="'tenantId'"
          :filter="'contains'"
        >
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="page-body" v-if="selectedProdName == 'ETMS'">
      <div class="d-flex w-100 pb-4">
        <div class="w-50">
          <span class="title-text">Number of Trips</span>
        </div>
      </div>
      <trip-bar-chart
        v-if="isLoadedETMS"
        :selectedTenant="tenantId"
        :selectedYear="getTripYear"
        :dashboardData="getTrips"
      ></trip-bar-chart>
    </div>

    <div class="d-flex m-1">
      <div class="new-page-body mx-3 mt-3" v-if="passingDataToPieChart == 'VTS'">
        <div class="d-flex w-100">
          <div class="w-100 p-tblr-1">
            <span class="title-text">Number of Vehicles</span>
          </div>
        </div>
        <pie-chart
          :width="200"
          :height="200"
          v-if="loaded"
          :selectedProduct="passingDataToPieChart"
          :selectedTenant="tenantId"
        ></pie-chart>
      </div>
      <div class="new-page-body m-3" v-if="passingDataToPieChart === 'ETMS'">
        <div class="d-flex w-100">
          <div class="w-100 p-tblr-1">
            <span class="title-text">Number of Employees </span>
          </div>
        </div>
        <pie-chart
          :width="200"
          :height="200"
          v-if="isLoadedEmployee"
          :selectedProduct="passingDataToPieChart"
          :dashboardData="noOfTrips"
          :selectedTenant="tenantId"
        ></pie-chart>
      </div>
      <div class="new-page-body m-3" v-if="passingDataToPieChart === 'VTS'">
        <div class="d-flex w-100">
          <div class="w-100 p-tblr-1">
            <span class="title-text"> Device details </span>
          </div>
        </div>
        <vehicle-pie-chart
          :width="200"
          :height="200"
          v-if="loaded"
          :selectedProduct="passingDataToPieChart"
          :selectedTenant="tenantId"
        ></vehicle-pie-chart>
      </div>
      <div
        class="new-page-body m-3"
        v-if="passingDataToPieChart === 'ETMS' && loadedVehicle"
      >
        <div class="d-flex w-100">
          <div class="w-100 p-tblr-1 d-flex justify-content-between">
            <span class="title-text"> Vehicles details </span>
            <div v-if="passingDataToPieChart === 'ETMS'">
              <kendo-dropdownlist
                :data-source="vehicleDetailsETMS"
                :value="vendorId"
                :data-text-field="'vendorName'"
                :data-item-key="'vendorId'"
                :data-value-field="'vendorId'"
                @change="selectedVender"
                :filter="'contains'"
              />
            </div>
          </div>
        </div>
        <vehicle-pie-chart
          :width="200"
          :height="200"
          v-if="loadedVehicle"
          :selectedProduct="passingDataToPieChart"
          :vehicles="getVehicle"
        ></vehicle-pie-chart>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./BarChart";
import TripBarChart from "./TripBarChart";
import PieChart from "./PieChart";
import VehiclePieChart from "./VehiclePieChart";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers(
  "dashboard"
);
// import { mapActions } from 'vuex';

export default {
  components: {
    BarChart,
    PieChart,
    TripBarChart,
    VehiclePieChart,
  },
  data() {
    return {
      datacollection: null,
      selectedProd: 0,
      selectedYr: new Date().getFullYear(),
      loaded: false,
      loadedPage: false,
      selectedProdName: "VTS",
      tenantId: "",
      empTenantId: "",
      deviceTenantId: "",
      vehicleTenantId: "",
      selectedTripYear: new Date().getFullYear(),
      tenantTripsArray: [],
      vendorId: "",
      isLoadedETMS: false,
      isLoadedEmployee: false,
      loadedVehicle: false,
    };
  },

  computed: {
    ...mapState([
      "dashboard",
      "prods",
      "years",
      "currentYear",
      "activatedTenants",
      "noOfTrips",
      "noOfVehicles",
      "vehicleDetailsETMS",
    ]),
    ...mapMutations(["getTenantDetailsOnYear", "setCurrentYear"]),
    ...mapGetters(["getTenantsByTrips"]),
    getProducts() {
      return this.prods;
    },
    // selectedFacility() {
    //   console.log("Default : ",this.currentYear)
    //   return this.$store.state.products[0];
    // },
    getTenantData(){
      if(this.selectedProdName == 'ETMS'){
        return this.noOfTrips;
      }
      else{
        return this.noOfVehicles;
      }
      
    },
    getYears() {
      return this.years;
    },
    getTrips() {
      return this.tenantTripsArray;
    },
    getTripYear() {
      return this.selectedTripYear;
    },
    passingDataToBarChart() {
      return [this.selectedProd, this.selectedYr];
    },
    passingDataToPieChart() {
      return this.selectedProdName;
    },
    passingTenantId() {
      return [this.tenantId, this.selectedTripYear];
    },
    getTenantId: {
      get() {
        return this.tenantId
          ? this.tenantId
          : this.selectedProdName == "ETMS" && this.noOfTrips[0]?.tenantId
          ? this.noOfTrips[0]?.tenantId
          : this.selectedProdName == "VTS" && this.noOfVehicles[0]?.tenantId
          ? this.noOfVehicles[0].tenantId
          : null;
      },
      set(val) {
        this.tenantId = val;
      },
    },
    getVehicle() {
      return this.vehicleDetailsETMS.filter(
        (vehicle) => vehicle.vendorId == this.vendorId
      );
    },
  },
  methods: {
    selectedProduct(e) {
      this.loaded = false;
      this.selectedProdName = e.sender._oldText;
      this.selectedProd = e.sender._cascadedValue;
      if (!this.selectedYr) {
        this.selectedYr = new Date().getFullYear();
      }
      this.getDataOnload();
      this.$mount();
      this.loaded = true;
    },
    async selectedYear(e) {
      this.loaded = false;
      this.selectedYr = e.sender._cascadedValue;
      this.selectedTripYear = e.sender._cascadedValue;
      await this.getDataOnload();
      this.$mount();
      this.loaded = true;
    },
    selectedTenant(e) {
      this.loaded = false;
      this.isLoadedETMS = false;
      this.tenantId = e.sender._cascadedValue;
      this.$mount();
      this.loaded = true;
      this.isLoadedETMS = true;
    },
    selectedVender(e) {
      this.vendorId = e.sender._cascadedValue;
      this.loadedVehicle = false;
      this.$mount();
      this.loadedVehicle = true;
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    async getDataOnload() {
      this.isLoadedETMS = false;
      this.loadedVehicle = false;
      await this.$store.dispatch("dashboard/getProducts");
      await this.$store.dispatch("dashboard/getYears");
      await this.$store.dispatch("dashboard/getTenantDetailsOnProductName", this.selectedProdName);
      this.tenantId = this.noOfVehicles[0]?.tenantId ? this.noOfVehicles[0].tenantId : null;
      if (this.selectedProdName == "ETMS") {
        let data = {
          productName: this.selectedProdName,
          year: this.selectedTripYear
            ? this.selectedTripYear
            : this.currentYear,
        };
        await this.$store.dispatch(
          "dashboard/getTenantTripDetailsOnProductName",
          data
        );
        this.tenantId = this.noOfTrips[0].tenantId;
        this.tenantTripsArray = this.noOfTrips;
        await this.$store.dispatch("dashboard/getVenderAndVehicleDetails", {
          tenantId: this.tenantId,
          year: this.selectedTripYear,
        });
        this.vendorId = "";
      }
      this.isLoadedETMS = true;
      this.loadedVehicle = true;
    },
  },
  async mounted() {
    await this.getDataOnload();
    this.loaded = true;
    this.loadedPage = true;
    this.isLoadedETMS = true;
    this.isLoadedEmployee = true;
    this.loadedVehicle = true;
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.page-body {
  width: 97%;
  background-color: white;
  margin: 10px auto;
  padding: 15px;
}

.p-tblr-1 {
  padding: 1rem;
}

.new-page-body {
  width: 48%;
  height: 500px !important;
  background-color: white;
}
.k-widget {
  margin-right: 1rem;
}
</style>
